// Shared styling for the redesigned backtest results (DWLF-306): Signal tokens and type.
export const tok = (t) => `var(--dwlf-${t})`;
export const LABEL = { fontFamily: '"Space Mono", monospace', textTransform: 'uppercase', letterSpacing: '0.12em' };
export const MONO = '"IBM Plex Mono", monospace';
export const GROTESK = '"Space Grotesk", sans-serif';

export const panelSx = { border: `1px solid ${tok('ink-08')}`, backgroundColor: tok('surface'), p: 2.5 };
export const titleSx = { ...LABEL, fontSize: '0.6875rem', color: tok('ink-55'), m: 0, mb: 1.5 };

export const fmtPct = (v, digits = 2) => (v === null || v === undefined ? '—' : `${v > 0 ? '+' : ''}${v.toFixed(digits)}%`);
export const fmtMoney = (v) => (v === null || v === undefined ? '—'
  : `${v < 0 ? '−' : ''}$${Math.abs(v).toLocaleString('en-GB', { maximumFractionDigits: 0 })}`);
export const fmtNum = (v, digits = 2) => (v === null || v === undefined ? '—' : v.toFixed(digits));
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: '2-digit' }) : '—');
